import "./PublicItinerary.scss";
import React, { useState, useEffect, useRef, forwardRef } from "react";
import { Link, useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import Collapse from 'react-bootstrap/Collapse';
import ReactStars from "react-rating-stars-component";
import TextareaAutosize from 'react-textarea-autosize';
import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    LinkedinShareButton,
    LinkedinIcon,
    EmailShareButton,
    EmailIcon,
    XIcon
} from "react-share";
import likeIcon from '../../../../../assets/images/like-icon.png';
import likeIconBlue from '../../../../../assets/images/like-icon-blue.png';
import chatIcon from '../../../../../assets/images/chat-icon.png';
import starIcon from '../../../../../assets/images/star-icon.png';
import { useAuth } from "../../../../../contexts/AuthProvider";
import { addItineraryCommentApi, addItineraryLikeApi, addItineraryRatingApi, getAllItineraryApi } from "../../../../../services/CmsService";
import { addExistingTripApi, getSubscriptionStatusService, getUserItineraryListApi, mergeItineraryApi } from "../../../../../services/AdminService";
import { getCityWiseItinerary, getCountryWiseItinerary, getDateWiseItinerary, getDaysWiseItinerary, getPriceWiseItinerary, getRatingWiseItinerary, getTravellersWiseItinerary, sortWiseItinerary } from "../../../../../helpers/ItineraryFilter";
import { toast } from "react-toastify";
import { PublicItineraryPlaceholder } from "../../../../../components/skeleton-placeholder";
import GalleryLightbox from "../../../../../components/gallery-lightbox";
import { NoDataFound } from "../../../../../components/no-data-found";
import { findCountryCity, findMinMaxAmount, totalItineraryDaysDetailsCount } from "../../../../../helpers";
import WarningModal from "../../../../../components/warning-modal";


const PublicItinerary = forwardRef(({
    filters,
    setFilters,
    setTotalItinerary,
    perPageChange,
    paginationChange,
    sizePaginate,
    currentPaginate,
    showExisting,
    setDefaultMaxPrice
}, ref) => {
    const { authed, currencyData } = useAuth();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [itineraryPublicData, setItineraryPublicData] = useState([]);
    const totalStars = 5;
    const [isOpenCollapse, setIsOpenCollapse] = useState(false);
    const [itineraryId, setItineraryId] = useState("");
    const itineraryRef = useRef([]);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [message, setMessage] = useState("");
    const [isMergeLoading, setIsMargeLoading] = useState(false);
    const [isExistingLoading, setIsExistingLoading] = useState(false);
    const [shareLink, setShareLink] = useState("");

    const getItineraryPublicData = async () => {
        setIsLoading(true);
        await getAllItineraryApi({
            type_of_itinerary: "Public",
            newCurrency: currencyData?.currency
        }, async (res) => {
            setIsLoading(false);
            // console.log("res getAllItineraryApi ====", res);
            if (res.status === 200) {
                if (res?.data?.success) {
                    const result = res?.data?.data?.sort((a, b) => new Date(a.updatedAt) < new Date(b.updatedAt) ? 1 : -1);
                    const maxValue = findMinMaxAmount(result);
                    setItineraryPublicData(result);
                    setDefaultMaxPrice(maxValue);
                    setFilters((prev) => ({
                        ...prev,
                        priceRange: { ...prev.priceRange, max: maxValue }
                    }));
                }
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const likeUnlikeButton = (likeData, item, index) => {
        const hasUserLiked = likeData.some(item => item?.userId === authed?.user?._id);

        return (
            <button
                type="button"
                className={`btn btn-border-color h-like-btn ${hasUserLiked ? "active" : "inactive"}`}
                onClick={(e) => handleItineraryLikeToggle(item, index)}
            >
                <img
                    width="16"
                    src={hasUserLiked ? likeIconBlue : likeIcon}
                    alt="Like icon"
                />
                ({item?.total_like})
            </button>
        );
    };

    const commentButton = (commentData, item, index) => {
        const hasUserCommented = commentData.some(comment => comment?.userId?._id === authed?.user?._id);
        return (
            <button type="button" onClick={(e) => handleItinerariesComment(item, e, index)} className={`btn btn-border-color btn-comment ${hasUserCommented ? "active" : "inactive"}`}>
                <i className={`bi ${hasUserCommented ? "bi-chat-dots-fill" : "bi-chat-dots"}`}></i>
                ({item?.total_comment})
            </button>
        )
    }

    const ratingButton = (ratingData, item, index) => {
        const hasUserRated = ratingData.some(rating => rating?.userId === authed?.user?._id);
        return (
            <Dropdown className="rating-itinerary-drp">
                <Dropdown.Toggle className={`btn btn-border-color btn-rating ${hasUserRated ? "active" : "inactive"}`}>
                    <span onClick={(e) => handleItineraryRating(item, e, index)}>
                        <i className={`bi ${hasUserRated ? "bi-star-fill" : "bi-star"}`}></i>
                        ({item?.total_rating})
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item>
                        <ReactStars
                            count={5}
                            onChange={ratingChanged}
                            size={16}
                            isHalf={false}
                            emptyIcon={<i className="bi bi-star"></i>}
                            halfIcon={<i className="bi bi-star-half"></i>}
                            filledIcon={<i className="bi bi-star-fill"></i>}
                            activeColor="#FFA800"
                        />
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    const handleItineraryLikeToggle = async (data) => {
        const isPostLiked = data?.likeData?.some(item => item?.userId === authed?.user?._id);

        let updatedPosts = itineraryPublicData.map((post) => {
            if (post?._id === data?._id) {
                if (isPostLiked) {
                    return {
                        ...post,
                        likeData: post?.likeData?.filter((item) => item?.userId !== authed?.user?._id),
                        total_like: post?.total_like - 1
                    };
                } else {
                    return {
                        ...post,
                        likeData: post?.likeData?.concat({
                            like: true,
                            isActive: true,
                            userId: authed?.user?._id,
                            itineraryId: data?._id
                        }),
                        total_like: post?.total_like + 1
                    };
                }
            }
            return post;
        });

        setItineraryPublicData(updatedPosts);

        await addItineraryLikeApi({ userId: authed?.user?._id, itineraryId: data?._id }, async (res) => {
            if (res.status === 200) {
                console.log(`${isPostLiked ? 'Unlike' : 'Like'} data updated successfully!`);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    };

    const handleItinerariesComment = (data, e, i) => {
        if (data?._id) setItineraryId(data?._id);

        if (isOpenCollapse === i) {
            setIsOpenCollapse(false);
        } else {
            setIsOpenCollapse(i);
            commentFormik.resetForm();
        }
    }
    const commentFormik = useFormik({
        initialValues: {
            comment: "",
            userId: authed?.user?._id || "",
            itineraryId: itineraryId || ""
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            comment: Yup.string()
                .required('Please enter your comments.'),
        }),
        onSubmit: async (values) => {
            // console.log('comment value:', values);
            let updatedPosts = itineraryPublicData.map(post => {
                if (post._id === values.itineraryId) {
                    let existingComments = post.commentData || [];
                    const hasUserCommented = existingComments.some(comment => comment?.userId?._id === authed?.user?._id);
                    return {
                        ...post,
                        commentData: [...existingComments, {
                            comment: values.comment,
                            userId: {
                                _id: authed?.user?._id,
                                name: authed?.user?.name,
                                profileImage: authed?.user?.profileImage
                            },
                            itineraryId: values.itineraryId,
                            createdAt: new Date().toISOString()
                        }],
                        total_comment: hasUserCommented ? post.total_comment : post.total_comment + 1
                    };
                }
                return post;
            });
            // console.log("updatedPosts===>", updatedPosts)
            setItineraryPublicData(updatedPosts);
            commentFormik.resetForm();
            // return
            await addItineraryCommentApi(values, async (res) => {
                if (res.status === 200) {
                    console.log("Comment Added successfully!");
                    if (res?.data?.message) {
                        toast.warning(res?.data?.message);
                    }
                    commentFormik.resetForm();
                } else {
                    console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                }
            });
            commentFormik.resetForm();
        }
    });

    const handleItineraryRating = (data) => {
        setItineraryId(data._id);
    }
    const ratingChanged = async (newRating) => {
        if (!newRating || !itineraryId) return;
        // console.log("newRatincccgValue===>", newRating)
        let updatedPosts = itineraryPublicData.map((post) => {
            if (post._id === itineraryId) {
                const existingRatings = post?.ratingata || [];
                const hasUserRated = existingRatings?.some((item) => item?.userId === authed?.user?._id);
                const newRatings = hasUserRated
                    ? existingRatings.map((rating) =>
                        rating?.userId === authed?.user?._id
                            ? {
                                ...rating,
                                rating: newRating,
                                createdAt: new Date().toISOString()
                            }
                            : rating
                    )
                    : [...existingRatings, {
                        userId: authed?.user?._id,
                        itineraryId: itineraryId,
                        rating: newRating,
                        createdAt: new Date().toISOString()
                    }];
                // console.log("newRatings=>>>", newRatings)
                const totalRatings = newRatings.reduce((acc, rating) => acc + rating.rating, 0);
                const averageRating = newRatings.length > 0 ? totalRatings / newRatings.length : 0;
                // console.log("averageRating==>", averageRating)
                return {
                    ...post,
                    ratingata: newRatings,
                    total_rating: newRatings.length,
                    avg_rating: averageRating,
                };
            }
            return post;
        });
        setItineraryPublicData(updatedPosts);
        // return
        await addItineraryRatingApi({
            rating: newRating,
            userId: authed?.user?._id,
            itineraryId: itineraryId
        }, async (res) => {
            if (res.status === 200) {
                console.log("Rating Added successfully!");
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }


    const handleItinerariesDetails = (e, data) => {
        // e.stopPropagation();
        history.push({
            pathname: '/details/',
            search: (`itineraryId=${data._id}`),
        });

    }
    const handleItinerariesEdit = async (data) => {
        setIsExistingLoading(true);
        const obj = {
            userId: authed?.user?._id,
            itineraryId: data._id,
            currency: currencyData.currency,
        }
        // console.log(obj)
        // return
        await addExistingTripApi(obj, async (res) => {
            setIsExistingLoading(false);
            if (res.status === 200) {
                // toast.success(res.data.data.message, options)
                document.body.click();
                history.push({
                    pathname: '/admin/create-itinerary/',
                    search: (`itineraryId=${res.data.data._id}`)
                });
            } else if (res.status === 422) {
                console.error("Validation Error:", res.data);
                setShowWarningModal(true);
                if (res?.data?.error) {
                    setMessage(res.data.error);
                }
            } else {
                console.error(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }
    const handleItineraryQuote = (data, e) => {
        history.push({
            pathname: '/admin/request-quote/',
            search: (`itineraryId=${data._id}`),
        });
    }
    const [itemItineraryId, setItemItineraryId] = useState({
        defaultItineraryId: "",
        itineraryId: "",
    });

    const handleGetItinerayId = (id) => {
        setItemItineraryId({ ...itemItineraryId, itineraryId: id, defaultItineraryId: "" });
        setFilterItineraryData(itineraryDraftList);
    }
    const handleMergeItinerary = async () => {
        setIsMargeLoading(true);
        const Obj = {
            defaultItineraryId: itemItineraryId.defaultItineraryId,
            itineraryId: itemItineraryId.itineraryId,
            currency: currencyData.currency
        }
        await mergeItineraryApi(Obj, async (res) => {
            // console.log("mergeItineraryApi res======", res);
            setIsMargeLoading(false);
            if (res.status === 200) {
                history.push({
                    pathname: '/admin/create-itinerary/',
                    search: (`itineraryId=${res.data.data._id}`),
                });
            } else if (res.status === 422) {
                console.error("Validation Error:", res.data);
                setShowWarningModal(true);
                if (res?.data?.error) {
                    setMessage(res.data.error);
                }
            } else {
                console.error(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const [itineraryDraftList, setItineraryDraftList] = useState([]);
    const [filterItineraryData, setFilterItineraryData] = useState([]);
    const [searchItineraryQuery, setSearchItineraryQuery] = useState("");
    const getItineraryDraftList = async () => {
        await getUserItineraryListApi({ userId: authed?.user?._id }, async (res) => {
            // console.log("API Get itinerary list response: ", res);
            if (res.status === 200) {
                const result = (res?.data?.data || []).sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);
                setItineraryDraftList(result);
                setFilterItineraryData(result);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    };

    const handleSearchItinerary = async (e) => {
        setSearchItineraryQuery(e.target.value);
        const filterResult = itineraryDraftList.filter(item => {
            if (e.target.value === "") return item
            return item.tour_name.toLowerCase().includes(e.target.value.toLowerCase())
        })
        await setFilterItineraryData(filterResult);
        await setItemItineraryId({ ...itemItineraryId, defaultItineraryId: "" });
        uncheckAllInputs([itineraryRef]);
    }

    const handleSelectItinerary = (e, item) => {
        setSearchItineraryQuery(e.target.value);
        setItemItineraryId({ ...itemItineraryId, defaultItineraryId: item._id });
    }

    const handleClearSearch = () => {
        setSearchItineraryQuery("");
        setFilterItineraryData(itineraryDraftList);
        setItemItineraryId({ ...itemItineraryId, defaultItineraryId: "" });
        uncheckAllInputs([itineraryRef]);
    }
    const handleMergeItineraryClose = () => {
        // document.body.click();
        setIsMargeLoading(false);
        setItemItineraryId({ defaultItineraryId: "", itineraryId: "" });
        setSearchItineraryQuery("");
        uncheckAllInputs([itineraryRef]);
    }
    const uncheckAllInputs = (refArray) => {
        if (!Array.isArray(refArray)) return;

        refArray.forEach(ref => {
            if (ref?.current?.forEach) {
                ref.current.forEach(input => input && (input.checked = false));
            }
        });
    };

    const handleBeforeShare = async (platform, id) => {
        // console.log(`Checking if sharing is allowed for ${platform}...`);
        return new Promise((resolve, reject) => {
            if (authed?.isAuth) {
                getSubscriptionStatusService({ itineraryId: id }, async (res) => {
                    // console.log("API Get getSubscriptionStatusService response: ", res);
                    if (res.status === 200) {
                        const url = `${process.env.REACT_APP_BASE_PATH}/details/?itineraryId=${id}`;
                        setShareLink(url);
                        resolve();
                    } else {
                        setShowWarningModal(true);
                        setMessage(res?.data?.error);
                        console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                        reject();
                    }
                });
            } else {
                history.push(`/signin`);
                reject();
            }
        });
    };


    const priceWiseItinerary = getPriceWiseItinerary(itineraryPublicData, filters.priceRange);
    const daysWiseItinerary = getDaysWiseItinerary(priceWiseItinerary, filters.dayRange);
    const ratingWiseItinerary = getRatingWiseItinerary(daysWiseItinerary, filters.travellerRating);
    const travellerTypeWiseItinerary = getTravellersWiseItinerary(ratingWiseItinerary, filters.travellerType);
    const datesWiseItinerary = getDateWiseItinerary(travellerTypeWiseItinerary, filters.dateRange);
    const countryWiseItinerary = getCountryWiseItinerary(datesWiseItinerary, filters.country);
    const cityWiseItinerary = getCityWiseItinerary(countryWiseItinerary, filters.city);
    const Itineraries = sortWiseItinerary(cityWiseItinerary, filters.sortType);
    // console.log("Itineraries===>", Itineraries);

    useEffect(() => {
        getItineraryPublicData();
        getItineraryDraftList();
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    {isLoading ? (
                        <PublicItineraryPlaceholder count={sizePaginate} />
                    ) : (
                        <>
                            {setTotalItinerary(Itineraries?.length || 0)}
                            {Itineraries?.length > 0 ?
                                Itineraries?.slice((currentPaginate - 1) * sizePaginate, currentPaginate * sizePaginate).map((item, i) => {
                                    const totalItems = totalItineraryDaysDetailsCount(item);
                                    return (
                                        <>
                                            {item.type_of_itinerary === "Public" &&
                                                <div className="itineraries-serach-item mt-40">
                                                    <div className="listitenaries-img-scroller" onClick={(e) => handleItinerariesDetails(e, item)}>
                                                        <ul className="listitenaries-img-ul">
                                                            {item?.destinationCityDetails?.map((cityItem) =>
                                                                cityItem?.itineraryDatys?.map((dayItem, dayIndex) =>
                                                                    dayItem?.itineraryDaysDetails?.map((dtItem, dtIndex) => (
                                                                        <GalleryLightbox
                                                                            key={`${dayIndex}-${dtIndex}`}
                                                                            thumbnails={dtItem.icon}
                                                                            data={dtItem}
                                                                        />
                                                                    ))
                                                                )
                                                            )}
                                                            {totalItems > 7 && (
                                                                <li className="lit-img-count-item cursor-pointer">
                                                                    <div className="lit-img-count-item-in">
                                                                        <span>+{Number(totalItems) - 7}</span>
                                                                    </div>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                    <div className="itineraries-captions-wrap">
                                                        <div className="itineraries-title">
                                                            <h4><span>@{item?.userId?.name}</span> built a <span>{item?.destinationCityDetails?.reduce((accumulator, current) => accumulator + current.itineraryDatys.length, 0)} Days</span> itinerary</h4>
                                                            <div className="itineraries-ratings">
                                                                {[...Array(totalStars)].map((star, index) => {
                                                                    return index < item.avg_rating && index + 1 > item.avg_rating ? <i className="bi bi-star-half"></i> : index < item.avg_rating ? <i className="bi bi-star-fill"></i> : <i className="bi bi-star"></i>;
                                                                })}
                                                            </div>
                                                        </div>
                                                        <p>
                                                            {item?.destinationCityDetails &&
                                                                findCountryCity(item?.destinationCityDetails).map((country, index) => (
                                                                    <span key={index}>
                                                                        {country.country} {index < country.length - 1 && " - "} (
                                                                        {country.cities.map((city, cityIndex) => (
                                                                            <span key={cityIndex}>
                                                                                {city}
                                                                                {cityIndex < country.cities.length - 1 && ", "}
                                                                            </span>
                                                                        ))}
                                                                        )
                                                                    </span>
                                                                ))
                                                            }
                                                            <span>&nbsp;|&nbsp;</span>
                                                            {item?.no_adult_travellers} adults {item?.no_children_travellers?.no_children !== 0 && ("and " + item?.no_children_travellers?.no_children + " Children")} {item?.no_infant_travellers !== 0 && ("and " + item?.no_infant_travellers + " Infants")} <span>|</span> Estimated cost: {currencyData?.currency} {Math.floor(item?.estimated_Cost)}
                                                        </p>
                                                        <div className="itineraries-btns">
                                                            <div className="itineraries-btn-left">
                                                                {authed?.isAuth === true ? (
                                                                    <>
                                                                        {item && likeUnlikeButton(item?.likeData, item, i)}
                                                                        {item && commentButton(item?.commentData, item, i)}
                                                                        {item && ratingButton(item?.ratingata, item, i)}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <button type="button" onClick={() => history.push(`/signin`)} className="btn btn-border-color"><img width="15" src={likeIcon} alt="Like icon" /> ({item?.total_like})</button>
                                                                        <button type="button" onClick={() => history.push(`/signin`)} className="btn btn-border-color"><i className="bi bi-chat-dots"></i> ({item?.total_comment})</button>
                                                                        <button type="button" onClick={() => history.push(`/signin`)} className="btn btn-border-color"><i className="bi bi-star"></i> ({item?.total_rating})</button>
                                                                    </>
                                                                )}

                                                            </div>
                                                            <div className="itineraries-btn-right">
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    trigger="click"
                                                                    rootClose
                                                                    overlay={
                                                                        <Popover>
                                                                            <Popover.Body className="share-popover-body-sty">
                                                                                <FacebookShareButton openShareDialogOnClick beforeOnClick={() => handleBeforeShare("Facebook", item._id)} url={shareLink || `${process.env.REACT_APP_BASE_PATH}`}>
                                                                                    <FacebookIcon size={24} round={true} />
                                                                                </FacebookShareButton>
                                                                                <WhatsappShareButton openShareDialogOnClick beforeOnClick={() => handleBeforeShare("Whatsapp", item._id)} url={shareLink || `${process.env.REACT_APP_BASE_PATH}`}>
                                                                                    <WhatsappIcon size={24} round={true} />
                                                                                </WhatsappShareButton>
                                                                                <TwitterShareButton openShareDialogOnClick beforeOnClick={() => handleBeforeShare("Twitter", item._id)} url={shareLink || `${process.env.REACT_APP_BASE_PATH}`}>
                                                                                    <XIcon size={24} round={true} />
                                                                                </TwitterShareButton>
                                                                                <EmailShareButton openShareDialogOnClick beforeOnClick={() => handleBeforeShare("Email", item._id)} url={shareLink || `${process.env.REACT_APP_BASE_PATH}`}>
                                                                                    <EmailIcon size={24} round={true} />
                                                                                </EmailShareButton>
                                                                                {/* <LinkedinShareButton url={`${process.env.REACT_APP_BASE_PATH}/details/?itineraryId=${item._id}`}>
                                                                                    <LinkedinIcon size={24} round={true} />
                                                                                </LinkedinShareButton> */}
                                                                            </Popover.Body>
                                                                        </Popover>
                                                                    }
                                                                >
                                                                    <button type="button" className="btn btn-border-color itinerary-btn-merge">
                                                                        <span className="tooltip bs-tooltip-bottom" role="tooltip">
                                                                            <span className="tooltip-arrow"></span>
                                                                            <span className="tooltip-inner">
                                                                                Share
                                                                            </span>
                                                                        </span>
                                                                        <i className="bi bi-share"></i>
                                                                    </button>
                                                                </OverlayTrigger>
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip>
                                                                            View Details
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <button type="button" onClick={(e) => handleItinerariesDetails(e, item)} className="btn btn-border-color"><i className="bi bi-eye"></i></button>
                                                                </OverlayTrigger>
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip>
                                                                            Request Quote
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    {authed?.isAuth === true ?
                                                                        <button type="button" onClick={(e) => handleItineraryQuote(item, e)} className="btn btn-border-color"><i className="bi bi-chat-quote"></i></button>
                                                                        : <button type="button" onClick={() => history.push(`/signin`)} className="btn btn-border-color"><i className="bi bi-chat-quote"></i></button>}
                                                                </OverlayTrigger>

                                                                {showExisting === true ? <OverlayTrigger
                                                                    trigger="click"
                                                                    placement="top"
                                                                    rootClose
                                                                    overlay={
                                                                        <Popover>
                                                                            <Popover.Body className="delete-popover-body-sty">
                                                                                <h6>Are you sure?</h6>
                                                                                <p>Customize this itinerary</p>
                                                                                <div className="delete-btn-groups mt-2">
                                                                                    <button onClick={(e) => handleItinerariesEdit(item, e)} type="button" className="btn btn-primary-color" disabled={isExistingLoading}>{isExistingLoading ? "Loading..." : "Yes"}</button>
                                                                                    <button onClick={() => document.body.click()} type="button" className="btn btn-danger ms-2">No</button>
                                                                                </div>
                                                                            </Popover.Body>
                                                                        </Popover>
                                                                    }
                                                                >
                                                                    <button type="button" className="btn btn-primary-color itinerary-btn-edit">
                                                                        <span className="tooltip bs-tooltip-bottom" role="tooltip">
                                                                            <span className="tooltip-arrow"></span>
                                                                            <span className="tooltip-inner">
                                                                                Customize itinerary
                                                                            </span>
                                                                        </span>
                                                                        <i className="bi bi-pencil"></i>
                                                                    </button>
                                                                </OverlayTrigger> : null}


                                                                {authed?.isAuth === true ?
                                                                    <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="top"
                                                                        rootClose
                                                                        onExit={handleMergeItineraryClose}
                                                                        overlay={
                                                                            <Popover className="merge-itinerary-bx">
                                                                                <Popover.Header as="div">
                                                                                    <div className="mi-header-searchbar">
                                                                                        <input type="text" onChange={handleSearchItinerary} value={searchItineraryQuery} className="form-control" placeholder="Search itineraries to merge..." />
                                                                                        {searchItineraryQuery && <button type="button" className="btn btn-clear" onClick={handleClearSearch}><i className="bi bi-x"></i></button>}
                                                                                    </div>
                                                                                </Popover.Header>
                                                                                <Popover.Body>
                                                                                    <div className="merge-itinerary-body">
                                                                                        {filterItineraryData?.length > 0 && filterItineraryData?.map((iteml, dl) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <div className="form-check">
                                                                                                        <input className="form-check-input" onChange={(e) => handleSelectItinerary(e, iteml)} value={iteml.tour_name} ref={(element) => { itineraryRef.current[dl] = element }} type="radio" name="idl" id={`idl_${dl + 1}`} />
                                                                                                        <label className="form-check-label" htmlFor={`idl_${dl + 1}`}>{iteml.tour_name}</label>
                                                                                                    </div>
                                                                                                </>
                                                                                            )
                                                                                        })}
                                                                                        {filterItineraryData?.length === 0 ?
                                                                                            <div className="text-center ">
                                                                                                <p><small>You do not have any draft itineraries to merge. Click to <Link to="/admin/create-itinerary">add new</Link></small></p>
                                                                                            </div> : null}
                                                                                    </div>
                                                                                </Popover.Body>
                                                                                <div className="popover-footer">
                                                                                    <button type="button" onClick={() => handleMergeItinerary()} disabled={itemItineraryId.defaultItineraryId === "" || isMergeLoading === true} className="btn btn-primary-color">{isMergeLoading ? "Merging..." : "Merge"}</button>
                                                                                    <button type="button" onClick={() => { handleMergeItineraryClose(); document.body.click(); }} className="btn btn-danger ms-2">Cancel</button>
                                                                                </div>
                                                                            </Popover>
                                                                        }>
                                                                        <button type="button" className="btn btn-border-color itinerary-btn-merge" onClick={() => handleGetItinerayId(item._id)}>
                                                                            <span className="tooltip bs-tooltip-bottom" role="tooltip">
                                                                                <span className="tooltip-arrow"></span>
                                                                                <span className="tooltip-inner">
                                                                                    Merge itinerary
                                                                                </span>
                                                                            </span>
                                                                            <i className="bi bi-plus-lg"></i>
                                                                        </button>
                                                                    </OverlayTrigger>

                                                                    : <OverlayTrigger
                                                                        placement="bottom"
                                                                        overlay={<Tooltip>Merge itinerary</Tooltip>}
                                                                    >
                                                                        <button type="button" onClick={() => history.push(`/signin`)} className="btn btn-border-color"><i className="bi bi-plus-lg"></i></button>
                                                                    </OverlayTrigger>
                                                                }

                                                            </div>
                                                        </div>
                                                        <Collapse in={isOpenCollapse === i}>
                                                            <div className="itinerary-comment-box">
                                                                <form onSubmit={commentFormik.handleSubmit} className="d-flex comnt-iti-txtarea">
                                                                    <div className="d-col-input-field">
                                                                        <TextareaAutosize maxLength={160}
                                                                            onChange={commentFormik.handleChange}
                                                                            onBlur={commentFormik.handleBlur}
                                                                            value={commentFormik.values.comment}
                                                                            name="comment" className="form-control"
                                                                            placeholder="Write a Comment..."
                                                                        />
                                                                        {/* <span className="txt-limit-area">{commentFromik.values.comment.length}/160 Characters</span> */}
                                                                    </div>
                                                                    <button disabled={!(commentFormik.isValid && commentFormik.dirty)} type="submit" className="btn btn-primary-color btn-border-color"><i className="bi bi-send-fill"></i></button>
                                                                </form>
                                                            </div>
                                                        </Collapse>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    )
                                })
                                :
                                <NoDataFound text="No itinerary found" />
                            }
                        </>
                    )}
                    <Pagination
                        className="pagination-style text-end mt-4"
                        showTitle={false}
                        showTotal={(total, range) => `Showing ${range[0]} - ${range[1]} itineraries of ${total} itineraries`}
                        onChange={paginationChange}
                        total={Itineraries?.length || 0}
                        current={currentPaginate}
                        pageSize={sizePaginate}
                        showSizeChanger={false}
                        onShowSizeChange={perPageChange}
                        hideOnSinglePage={true}
                    />
                </div>
            </div>
            {showWarningModal && (
                <WarningModal
                    type={"Plan"}
                    message={message}
                    showWarningModal={showWarningModal}
                    setShowWarningModal={setShowWarningModal}
                    isLoading={""}
                />
            )}
        </>
    )
});

export default PublicItinerary;